"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var AcTableActionCell_module_scss_1 = __importDefault(require("./AcTableActionCell.module.scss"));
var Button_1 = __importDefault(require("react-bootstrap/Button"));
var configs = {
    email: {
        icon: 'fal fa-at',
    },
    phone: {
        icon: 'fal fa-phone',
    },
    mobile: {
        icon: 'fal fa-mobile-android',
    },
};
exports.AcTableContactCell = function (props) {
    var _a = props.contacts, contacts = _a === void 0 ? [] : _a;
    var history = react_router_dom_1.useHistory();
    var buttons = contacts.map(function (contact, index) {
        var config = configs[contact.type];
        if (!config) {
            config = {};
        }
        return (react_1.default.createElement(Button_1.default, { size: "sm", key: index, 
            // onClick={onClick}
            className: "text-body", variant: "link" },
            react_1.default.createElement("i", { className: config.icon + " " + AcTableActionCell_module_scss_1.default.actionBtnIcon + " fa-fw fs-12 mr-1" })));
    });
    return react_1.default.createElement("div", { className: "d-flex flex-column align-items-start" }, buttons);
};
exports.AcTableContactCell.displayName = 'AcTableContactCell';
//# sourceMappingURL=AcTableContactCell.js.map